import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import JobCardFreelancer from '@/partials/JobCards/JobCardFreelancer/JobCardFreelancer.vue'

const JOBS_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    JobCardFreelancer,
    InfiniteLoading,
  },
  data() {
    return {
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState({
      jobs: (state: any) => state.myJobs.workerAll.values,
      isLoading: (state: any) => state.myJobs.workerAll.isLoading,
      isLoaded: (state: any) => state.myJobs.workerAll.isLoaded,
      pagination: (state: any) => state.myJobs.workerAll.pagination,
    }),
  },
  async created() {
    await this.load({ limit: JOBS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myJobs/loadWorkerAll',
      loadMore: 'myJobs/loadMoreWorkerAll',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.jobs.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: JOBS_LIMIT, offset: this.jobs.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Jobs - All'),
    }
  },
})
